import { define } from "../preactement/define";
import { SingleInputDateField } from "../../DateField";
import { parseBooleanAttr, parseDateAttr, parseIntegerAttr } from "../wrapperUtils";
import { formAttrs } from "../shared-attributes/form";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = ['name', 'root-id', 'inversed', 'value', 'default-month', 'from-date', 'from-month', 'from-year', 'to-date', 'to-month', 'to-year', ...formAttrs];
const Wrapper = _ref => {
  let {
    rootId,
    inversed,
    defaultMonth,
    fromDate,
    fromMonth,
    fromYear,
    toDate,
    toMonth,
    toYear,
    value,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(SingleInputDateField, {
    id: rootId,
    inversed: parseBooleanAttr(inversed),
    defaultValue: value,
    defaultMonth: parseDateAttr(defaultMonth),
    fromDate: parseDateAttr(fromDate),
    fromMonth: parseDateAttr(fromMonth),
    fromYear: parseIntegerAttr(fromYear),
    toDate: parseDateAttr(toDate),
    toMonth: parseDateAttr(toMonth),
    toYear: parseIntegerAttr(toYear),
    ...otherProps
  });
};

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

define('ds-date-field', () => Wrapper, {
  attributes,
  events: [['onChange', (updatedValue, formattedValue, date) => ({
    detail: {
      updatedValue,
      formattedValue,
      date
    }
  })], 'onBlur']
});